import { toChatId } from '../../../utils/utils';
import { useSend } from '../../useApi';

// GET /admin/users/{chat_id}: find a customer by their WhatsApp number.
const useFindUser = () => {
  const { loading, send } = useSend<{ id: string; chat_id: string; display_name?: string | null }>('No customer with that number');
  return {
    finding: loading,
    findUser: (phone: string, onFound: (user: { id: string; chat_id: string; display_name?: string | null }) => void) => {
      send({ url: `api/v1/admin/users/${toChatId(phone)}`, method: 'get' }, onFound);
    },
  };
};

export default useFindUser;
